import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({ loading: true, authenticated: true, loginRequired: false, email: null, name: null });

  useEffect(() => {
    authApi.status()
      .then(res => setAuth({ loading: false, ...res.data }))
      .catch(() => setAuth({ loading: false, authenticated: true, loginRequired: false, email: null, name: null }));
  }, []);

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
